import splitUrl from '../utils/splitUrl';

/**
 * The full urls of where the pages will eventually be deployed.
 * Serves as the data source for `getStaticProps`
 * FULL URLS ONLY
 * -------------------------
 * @type {Array<string>}
 * -------------------------
 *  @example
 * export const PAGES = [
 *   'https://www.haaretz.co.il/smadar/EXT.premium.EXT-STATIC-1.9480030',
 *   'https://www.haaretz.co.il/health/corona/.premium-MAGAZINE-1.8802422',
 *   'https://www.haaretz.co.il/health/corona/.premium-1.8805016',
 * ];
 * -------------------------
 */
export const PAGES = [
  'https://www.haaretz.co.il/0000019a-773d-d326-a3ff-f73dcb3c0000', // replace ID in article ID
];

///////////////////////////////////
//  Bi | promotions | analytics ///
///////////////////////////////////

export const CAMPAGIN_NAME = ''; // Replace with the project's campaign name
export const BANNER_ID = 'purchaseBtn'; // Replace with the HTML ID of the (clickable) banner element
export const BANNER_IDS = [ BANNER_ID, ];
export const SHARE_TEXT = '';

export const CAMPAIGN_DETAILS = 'רכשו מינוי'; // Replace with the project's campaign details
export const FEATURE_TYPE = 'Marketing';

///////////////////////////////////

/**
 * The application's language
 * -------------------------
 * @type {'he'|'en'}
 * -------------------------
 */
export const LANG = 'he';
export const SITE = 'haaretz.co.il';

export const PAGES_URL_PARTS = (pages => {
  if (!pages.length) {
    throw new Error('no urls are defined in the "PAGES" array. See "consts/index.js"');
  }

  return pages.map(url => {
    const {
      baseUrl,
      fqdn,
      domain,
      fullMatch,
      path = '',
      query,
    } = splitUrl(url);
    const id = (path.match(/^.*\/.*?(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/i) || [])[1];
    const formatterQuery = `${query ? '&' : '?'}_renderer=json&ts=${Date.now()}`;

    return {
      baseUrl,
      id,
      path,
      url: fullMatch,
      domain: domain?.toLowerCase(),
      fqdn,
      formatterQuery,
    };
  });
})(PAGES);
